import { type ExportViewRecordsFormat } from '@/hooks/api/queries/useExportViewRecordsQuery';

export function downloadExportedFile(
  exportTableFormat: ExportViewRecordsFormat,
  exportTableData: Blob,
  fileName: string
) {
  // The server is expecting text instead of txt, so we need to convert back to txt
  const fileFormat = exportTableFormat === 'text' ? 'txt' : exportTableFormat;
  const downloadUrl = URL.createObjectURL(exportTableData);
  const temporaryLink = document.createElement('a');
  temporaryLink.href = downloadUrl;
  temporaryLink.download = `${fileName}.${fileFormat}`;
  temporaryLink.click();
  URL.revokeObjectURL(downloadUrl);
}
